import servicesUtils from '../utils/service'

export const safetyAlertServices = {
    /**
     * 警示列表(以日記分組、分頁)
     * @param {Object} payload { homework_id?, status?, page, page_size }
     */
    async getAlerts(payload) {
        try {
            const url = `${servicesUtils.resourceUrl('getSafetyAlerts')}` + '?' + servicesUtils.queryParams(payload)
            const data = await servicesUtils.get(url)
            return data
        } catch (err) {
            console.log(`failed to get getSafetyAlerts err: ${err}`)
            throw err
        }
    },

    /**
     * 未處理警示摘要 { unhandled_count, max_severity }(供警示條/badge)
     * @param {number|null} homeworkId 有值時只看該日記本
     */
    async getSummary(homeworkId = null) {
        try {
            let url = `${servicesUtils.resourceUrl('getSafetySummary')}`
            if (homeworkId != null) {
                url += '?' + servicesUtils.queryParams({ homework_id: homeworkId })
            }
            const data = await servicesUtils.get(url)
            return data
        } catch (err) {
            console.log(`failed to get getSafetySummary err: ${err}`)
            throw err
        }
    },

    /**
     * 取得單篇日記的警示群組(無警示或無權限回 { alert: null })
     * @param {string} diaryPostId
     */
    async getByPost(diaryPostId) {
        try {
            const url = `${servicesUtils.resourceUrl('updateSafetyAlertsByPost')}`.replace(':postId', diaryPostId)
            const data = await servicesUtils.get(url)
            return data
        } catch (err) {
            console.log(`failed to get getSafetyAlertsByPost err: ${err}`)
            throw err
        }
    },

    /**
     * 批次取得多篇日記的警示群組(News 動態牆用)
     * @param {string[]} diaryPostIds
     * @returns { alerts: { [diaryPostId]: 群組 } } 無警示的 post 不會出現
     */
    async getByPosts(diaryPostIds) {
        try {
            const url = `${servicesUtils.resourceUrl('getSafetyAlertsByPosts')}` +
                '?' + servicesUtils.queryParams({ post_ids: diaryPostIds.join(',') })
            const data = await servicesUtils.get(url)
            return data
        } catch (err) {
            console.log(`failed to get getSafetyAlertsByPosts err: ${err}`)
            throw err
        }
    },

    /**
     * 批次更新一篇日記的全部警示狀態
     * @param {string} diaryPostId
     * @param {number} status 0=待處理 1=已通報 2=忽略
     */
    async updateByPost(diaryPostId, status) {
        try {
            const url = `${servicesUtils.resourceUrl('updateSafetyAlertsByPost')}`.replace(':postId', diaryPostId)
            const data = await servicesUtils.post(url, { status: status })
            return data
        } catch (err) {
            console.log(`failed to post updateSafetyAlertsByPost err: ${err}`)
            throw err
        }
    },
}
